import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";

import { useStyles } from "./OverallTimeTable.css";
import AdminHeader from "../../../../Components/NavBar/Admin/AdminHeader/AdminHeader";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import Axios from "axios";
import { url } from "../../../../Config/Config";
import CustomEmptyMessage from "../../../../Components/CustomEmptyMessage/CustomEmptyMessage";
import CustomSiteLoader from "../../../../Components/CustomSiteLoader/CustomSiteLoader";
import OverallDetails from "./OverallDetails/OverallDetails";
import OverallTimetableBody from "./OverallTimetableBody/OverallTimetableBody";
import TimeTableFormFilter from "../TimeTableFormFilter/TimeTableFormFilter";
import { getAdminRefreshToken } from "../../../../Redux/Actions/actions";
import PageTitle from "../../../../Components/PageTitle/PageTitle";
import CustomBreadCrumbs from "../../../../Components/CustomBreadCrumbs/CustomBreadCrumbs";

class OverallTimetable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      timeList: [],
      data: {
        class: "",
        faculty: "",
        group: "",
        section: "",
      },
    };
  }

  componentDidMount() {
    this.getTimeTable();
  }

  getTimeTable = async () => {
    try {
      const response = await Axios.get(`${url}/api/time-tables`, {
        headers: {
          Authorization: `Bearer ${this.props.adminToken}`,
        },
      });
      if (response.data.timeTables.length !== 0) {
        this.setState({
          timeList: response.data.timeTables,
          isEmpty: false,
        });
      } else {
        this.setState({
          timeList: [],
          isEmpty: true,
        });
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.getTimeTable();
      }
    }
  };

  handleChange = (e) => {
    this.setState({
      data: {
        ...this.state.data,
        [e.target.name]: e.target.value,
      },
    });
  };

  handleChangeClass = (e) => {
    this.setState({
      data: {
        ...this.state.data,
        class: e.target.value,
        faculty: "",
        group: "",
        section: "",
      },
    });
  };

  render() {
    const { classes } = this.props;
    const filtered = this.state.timeList.filter((data) => {
      return this.state.data.faculty && this.state.data.group
        ? data.studentClass.indexOf(this.state.data.class) !== -1 &&
            data.faculty.indexOf(this.state.data.faculty) !== -1 &&
            data.group.indexOf(this.state.data.group) !== -1 &&
            data.section.indexOf(this.state.data.section) !== -1
        : data.studentClass.indexOf(this.state.data.class) !== -1 &&
            data.section.indexOf(this.state.data.section) !== -1;
    });
    return (
      <div className={classes.root}>
        <AdminHeader />
        <div className={classes.content}>
          <div className={classes.toolbar} />

          <CustomBreadCrumbs url={this.props.match.url} />
          <PageTitle
            title="Overall TimeTable"
            refreshUrl={this.props.match.url}
          />
          <TimeTableFormFilter
            data={this.state.data}
            handleChange={this.handleChange}
            handleChangeClass={this.handleChangeClass}
          />
          {this.state.timeList.length !== 0 ? (
            filtered.map((data, index) => (
              <div key={index}>
                <OverallDetails classData={data} />
                <OverallTimetableBody times={data.times} />
              </div>
            ))
          ) : this.state.isEmpty ? (
            <CustomEmptyMessage />
          ) : (
            <CustomSiteLoader />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    isAdmin: state.AdminReducer.isAdmin,
    role: state.AdminReducer.role,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(OverallTimetable)));
